var $ = require('jquery');
// var imagesLoaded = require('imagesloadedwithsize');
var imgLoader = require('imgloader');
var cymasmooth = require('cymasmooth');

module.exports = function(el, callback){ // onShow
	// alert('cc')
	if ( cymasmooth.canPreloadAssets == false ){
		cymasmooth.canPreloadAssets = true; // used by site loader to prevent loading assets twice on first page load
		callback();
		return;
	}

	// alert('c')
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// console.log('ON SHOW DATA ATTR');
	// 
	// debugger;
	// $('body').get(0).offsetWidth;
	// var pages = $('.page__wrap');
	// console.log('pages.length', pages.length);
	// var page = $('.page__wrap').last().css('opacity', 1);
	var page = $('.page__wrap').last().get(0);
	// console.log('page', page);
	// $('body').get(0).offsetWidth;
	// debugger;
	imgLoader( $(page), function(){
		
	}, callback, 50 );
	return;

	var els = $(el).find('[data-src], [data-bg-src]').get();
	var src = [];
	$(el).find('img[data-src]').each(function(i, el){ // add img to avoid pb with fancybox cause it use data-src too
		console.log('el', el);
		src.push( $(el).attr('data-src') );
	})
	$(el).find('[data-bg-src]').each(function(i, el){
		console.log('elbg', el);
		src.push( $(el).attr('data-bg-src') );
	})
	console.log('src', src);
	imagesLoaded( src, function() {
		// alert('load done')
		$('[data-src], [data-bg-src]').each(function(i, el){
			// console.log('el', el);
			if ( $(el).attr('data-bg-src')  ) {
				$(el).css('background-image', 'url('+$(el).attr('data-bg-src')+')');
			}
			else {
				// console.log($(el).attr('data-src'));
				$(el).attr('src', $(el).attr('data-src'));
			}
		});
		setTimeout(callback, 50);
	});
};

